import { IInativarTreinamentoUseCase } from "../../../presentation/useCases/update/inativar_treinamentos_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * InativarTreinamentoUseCase
 */

export class InativarTreinamentoUseCase implements IInativarTreinamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async inativarTreinamentos(
    treinamentos: number[],
  ): Promise<void> {
    await this.repository.inativarTreinamentos(treinamentos);
  }
}
